export default __webpack_public_path__ + "static/experienced-sa-a49272fb2d8019083c99163fe6dabaca.webp";